import { render, staticRenderFns } from "./VesselSort.vue?vue&type=template&id=07880b2f&scoped=true&"
import script from "./VesselSort.vue?vue&type=script&lang=js&"
export * from "./VesselSort.vue?vue&type=script&lang=js&"
import style0 from "./VesselSort.vue?vue&type=style&index=0&id=07880b2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07880b2f",
  null
  
)

export default component.exports